import React, { useState, useEffect } from 'react';
import './styles/global.css';

import Header   from './components/Header/Header';
import Footer   from './components/Footer/Footer';
import Home     from './components/Home/Home';
import Reviews  from './components/Reviews/Reviews';
import HowTo    from './components/HowTo/HowTo';
import Contacts from './components/Contacts/Contacts';
import FAQ      from './components/FAQ/FAQ';

const PAGES = { home: Home, reviews: Reviews, howto: HowTo, contacts: Contacts, faq: FAQ };


export default function App() {
  const [activePage, setActivePage] = useState('home');

  // Scroll to top on page change
  useEffect(() => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  }, [activePage]);

  const PageComponent = PAGES[activePage] || Home;

  return (
    <div className="app">
      <Header activePage={activePage} onNavigate={setActivePage} />

      {/* Always offset by the full header height (banner + nav bar) */}
      <div style={{ paddingTop: 'var(--header-total-h)' }}>
        <PageComponent />
        <Footer onNavigate={setActivePage} />
      </div>
    </div>
  );
}
